import { render, staticRenderFns } from "./ResumenDashboard.vue?vue&type=template&id=bcf05d1a&scoped=true"
import script from "./ResumenDashboard.vue?vue&type=script&lang=js"
export * from "./ResumenDashboard.vue?vue&type=script&lang=js"
import style0 from "./ResumenDashboard.vue?vue&type=style&index=0&id=bcf05d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf05d1a",
  null
  
)

export default component.exports